module.exports = __webpack_public_path__ + "media/images/card_accepted-ad478462baeb3ad2b309dd8805eabd7d.png";